// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_components.js'; import './autoload/_vendors.js'

// Import everything from modules
//import './modules/components'; import './modules/components/_brands-slider.js'; import './modules/components/_header.js'; import './modules/components/_hero-slider.js'; import './modules/components/_one-page-header.js'; import './modules/components/_otherhotels-slider.js'; import './modules/components/_room-facilities-slider.js'; import './modules/components/_room-item-slider.js'; import './modules/components/_rooms-slider.js'; import './modules/components/_venue-slider.js'; import './modules/components/maps'; import './modules/components/maps/_hotels_map.js'; import './modules/components/maps/_map_style.js'; import './modules/components/maps/_map.js'; import './modules/components/maps/_our_brands_map.js'; import './modules/forms'; import './modules/forms/career-form.js'; import './modules/forms/contact.js'; import './modules/forms/form.js'; import './modules/forms/free-trial.js'; import './modules/forms/handbook-widget-form.js'; import './modules/forms/leftnav_form.js'; import './modules/forms/newsletter-form.js'; import './modules/same_sized_cards.js'; import './modules/scrollable-swiper.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import Utils from './util/utils';
import ENV from './env';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    // About Us page, note the change from about-us to aboutUs.

});

// Load Events
jQuery(document).ready(() => {

    Utils.init();
    setTimeout(() => {
        routes.loadEvents();
        Utils.showLoader(false);
    }, ENV.DELAY_INIT);

});


// WEBPACK FOOTER //
// ./scripts/main.js